// extracted by mini-css-extract-plugin
module.exports = {"cityPopup":"city_cityPopup__wChHK","cityHighlightCard":"city_cityHighlightCard__72_lf","highlightDescription":"city_highlightDescription__VIxzi"};